/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_To_ClipboardInputs */

const en_copy_to_clipboard = /** @type {(inputs: Copy_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy to clipboard as CSV`)
};

const nl_copy_to_clipboard = /** @type {(inputs: Copy_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieer naar klembord als CSV`)
};

/**
* | output |
* | --- |
* | "Copy to clipboard as CSV" |
*
* @param {Copy_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const copy_to_clipboard = /** @type {((inputs?: Copy_To_ClipboardInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_To_ClipboardInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_copy_to_clipboard(inputs)
	return en_copy_to_clipboard(inputs)
});